/**
 * Dialog close reasons Material UI reports for an accidental dismissal.
 *
 * A click on the backdrop or a press of Escape is easy to trigger by mistake
 * and discards anything typed into the dialog, so neither is treated as a
 * request to close. The title bar's X (and any Cancel button) remains the
 * deliberate way out.
 *
 * @type {string[]}
 */
export const dismissReasons = ['backdropClick', 'escapeKeyDown'];

/**
 * Wrap a Dialog close handler so accidental dismissals are ignored
 *
 * Material UI calls onClose with (event, reason); the X and Cancel buttons
 * call it with the click event alone, so those pass through untouched.
 *
 * @param onCloseFunc
 * @returns {function(*, *): void}
 */
export const nonDismissable = (onCloseFunc) => (event, reason) => {

    if (dismissReasons.includes(reason)) {
        return;
    }

    if (typeof onCloseFunc === 'function') {
        onCloseFunc(event, reason);
    }
};
